module.exports = __webpack_public_path__ + "img/39dba23df52b66b8c311d802d880cb27.e495394d.jpg";